import context from '../context'
import { allowErrorDialog } from '@/utils/fetch'

export const initialState = {
  fetching: false,
  workflowDefinitionVersion: null
}

export const actionTypes = {
  fetching: 'workflowDefinitionVersion/fetching',
  fetched: 'workflowDefinitionVersion/fetched',
  error: 'workflowDefinitionVersion/error'
}

export const actionCreators = {
  get: (id) => (dispatch) => {
    dispatch({ type: actionTypes.fetching })
    context.api.workflowDefinitionService.getVersionById(id, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, payload: response })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, workflowDefinitionVersion: action.payload }

    case actionTypes.error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/workflowDefinitionVersion.js